import React, { useEffect, useRef, useState } from 'react';
import { FiAlertTriangle, FiHelpCircle, FiLogOut } from 'react-icons/fi';
import './confirm-dialog.css';

// Themed replacement for window.confirm.
//   if (!(await confirmDialog({ title, message, confirmLabel, tone: 'danger' }))) return;
// <ConfirmHost /> is mounted once in App.jsx and renders whichever dialog is open.
let showDialog = null;

export function confirmDialog(options) {
  if (!showDialog) return Promise.resolve(window.confirm(options.message || options.title));
  return new Promise((resolve) => showDialog({ ...options, resolve }));
}

const ICONS = { danger: FiAlertTriangle, logout: FiLogOut, default: FiHelpCircle };

export function ConfirmHost() {
  const [dialog, setDialog] = useState(null);
  const confirmRef = useRef(null);

  useEffect(() => {
    showDialog = setDialog;
    return () => { showDialog = null; };
  }, []);

  const close = (result) => {
    dialog?.resolve(result);
    setDialog(null);
  };

  useEffect(() => {
    if (!dialog) return undefined;
    confirmRef.current?.focus();
    const onKey = (e) => {
      if (e.key === 'Escape') close(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  });

  if (!dialog) return null;
  const {
    title, message, details = [], note, confirmLabel = 'Confirm', cancelLabel = 'Cancel', tone = 'default',
  } = dialog;
  const Icon = ICONS[tone] || ICONS.default;

  return (
    <div className="nb-confirm-overlay" onClick={() => close(false)}>
      <div
        className={`nb-confirm is-${tone}`}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="nb-confirm-title"
        aria-describedby="nb-confirm-message"
        onClick={(e) => e.stopPropagation()}
      >
        <span className="nb-confirm-icon" aria-hidden="true"><Icon /></span>
        <h3 id="nb-confirm-title">{title}</h3>
        {message && <p id="nb-confirm-message">{message}</p>}
        {details.length > 0 && (
          <ul className="nb-confirm-details">
            {details.map((d) => <li key={d}>{d}</li>)}
          </ul>
        )}
        {note && <p className="nb-confirm-note">{note}</p>}
        <div className="nb-confirm-actions">
          <button type="button" className="nb-confirm-btn" onClick={() => close(false)}>{cancelLabel}</button>
          <button type="button" ref={confirmRef} className={`nb-confirm-btn is-primary is-${tone}`} onClick={() => close(true)}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
